gsap.registerPlugin(ScrollTrigger);

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};
jQuery(document).ready(function($) {
  
  if(getUrlParameter('cat')){
    $('article:not([data-category="'+getUrlParameter('cat')+'"])') .remove();
    $('.product__grid').css('visibility','visible');
  }
  if(getUrlParameter('tag')){
    $('article:not([data-tags*="'+getUrlParameter('tag')+'"])') .remove();
    $('.product__grid').css('visibility','visible');
  }
  
    //when scrolling...

  $('.sort__headline').on('click', function(){
    $(this).toggleClass('active');
    $(this).parent().find('.sort__content').slideToggle();
  });

	$('.intro__slider').flickity({
		// options
		cellAlign: 'left',
		freeScroll: true,
		pageDots: false,
		wrapAround: true
	});
	
	$('.news__slider').flickity({
		// options
		cellAlign: 'left',
		freeScroll: true,
		pageDots: false,
		wrapAround: true
	});
	
	
	$('.cat__slider').flickity({
		// options
		cellAlign: 'left',
		freeScroll: true,
		pageDots: false,
		wrapAround: true
	});
  
  	$('.team__slider').flickity({
		// options
		cellAlign: 'left',
		freeScroll: true,
		pageDots: false,
		wrapAround: true
	});
  
  	$('.about__image__slider').flickity({
		// options
		cellAlign: 'left',
		freeScroll: true,
		pageDots: false,
		wrapAround: true
	});
  
  $('.search__icon').on('click', function(){
    $('.search__holder').addClass('active');
     $('.switching__headlines').addClass('hidden');
    $('input.search__bar').focus();
  });
  
  $('input.search__bar').focusout(function() {
    $('.search__holder').removeClass('active');
    $('.switching__headlines').removeClass('hidden');
  });
	

    ScrollTrigger.matchMedia({

      // desktop
      "(min-width: 751px)": function() {
        
	
        $(document).on('mouseover', 'header.fixed .logo', function(){
            $('.overlay__nav').fadeIn();
        });

        $(document).on('mouseleave', '.overlay__nav ul', function(){
            $('.overlay__nav').fadeOut();
        });
        
        
        jQuery('.scrollwrapper').scroll(function() {
            //if I scroll more than 1000px...

          if($('body').hasClass('template-index')){


            if($('main').scrollTop() > 10){
                $('nav').slideUp(600);
            } else {
                $('nav').slideDown(600);
            }



            if($('aside').scrollTop() > 10 || $('main').scrollTop() > 10){
                $('header').addClass('fixed');

            } else {
                $('header').removeClass('fixed');

            }

          }

          var scrollBottomMain = $('main.scrollwrapper .inner__scrollwrapper').height() + $('header').height() - $(window).height() - $('main.scrollwrapper').scrollTop();
          var scrollBottomAside = $('aside.scrollwrapper .inner').height() + $('header').height() - $(window).height() - $('aside.scrollwrapper').scrollTop();

          if(scrollBottomMain < 10 || scrollBottomAside < 10){
            $('#shesaid__footer').addClass('active');
          } else {
            $('#shesaid__footer').removeClass('active');
          }
          console.log('Main'+scrollBottomMain);
          console.log('Aside'+scrollBottomAside);
        });
        
        gsap.utils.toArray("section[data-section]").forEach((section, i) => {
            console.log('hey');

            var sectionName = section.dataset.section;
            var sectionCatLeft = section.querySelector(".cat__left"); 



            if (sectionCatLeft != null) {
            gsap.to(sectionCatLeft, {
                scrollTrigger: {
                    scroller: "main.scrollwrapper",
                    trigger: sectionCatLeft,
                    start: "top top",
                    pin: true,
                    pinSpacing: false,
                    anticipatePin: 1,
                  	pinType: "fixed"
                }
            });
            }



            ScrollTrigger.create({
                scroller: "main.scrollwrapper",
                trigger: section,
                start: "top top",
                onToggle: self => {
                    //var sectionName = self.trigger.attributes[1].stringify();
                    //console.log("toggled, isActive:", self.isActive);
                    if(self.isActive){
                        console.log(sectionName);
                        //console.log(self.trigger.dataset.section);
                        //console.log(self.trigger.attributes[1]);
                        $('.headingTrigger:not([data-section="'+sectionName+'"])').removeClass('active');
                        $('.headingTrigger[data-section="'+sectionName+'"]').addClass('active');
                    }

                },
                onUpdate: self => {
                    //console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
                }
            });

        });
      },

      // mobile
      "(max-width: 750px)": function() {
        
        /*
        $('.article__content--left .article').on('click', function(){
          $(this).toggleClass('slidein');
        });
        */
        
        $(document).on('click', '.burger', function(){
            $('.overlay__nav').fadeIn();
          	$('.overlay__nav__bg').fadeIn();
        });
        
        $(document).on('click', '.overlay__nav__bg', function(){
            $('.overlay__nav').fadeOut();
          	$('.overlay__nav__bg').fadeOut();
        });
        
        $( window ).scroll(function() {
            //if I scroll more than 1000px...

          if($('body').hasClass('template-index')){


            if($('main').scrollTop() > 10){
                $('nav').slideUp(600);
            } else {
                $('nav').slideDown(600);
            }



            if($('aside').scrollTop() > 10 || $('main').scrollTop() > 10){
                $('header').addClass('fixed');

            } else {
                $('header').removeClass('fixed');

            }

          }

          var scrollBottomMain = $('main.scrollwrapper .inner__scrollwrapper').height() + $('header').height() - $(window).height() - $('main.scrollwrapper').scrollTop();
          var scrollBottomAside = $('aside.scrollwrapper .inner').height() + $('header').height() - $(window).height() - $('aside.scrollwrapper').scrollTop();

          if(scrollBottomMain < 10 || scrollBottomAside < 10){
            $('#shesaid__footer').addClass('active');
          } else {
            $('#shesaid__footer').removeClass('active');
          }
          console.log('Main'+scrollBottomMain);
          console.log('Aside'+scrollBottomAside);
        });
        
		
        ScrollTrigger.create({
          trigger: '.template-index .header__mobile__bottom',
          pin: true,
          pinSpacing: false,
          endTrigger:"#shesaid__footer",
          end:"bottom top",
          toggleClass: 'fixed',
          anticipatePin: 1
        });
        
        
        gsap.utils.toArray("section[data-section]").forEach((section, i) => {
            console.log('hey');

            var sectionName = section.dataset.section;
            var sectionCatLeft = section.querySelector(".cat__left"); 


            ScrollTrigger.create({
                trigger: section,
                start: "top top",
                onToggle: self => {
                    //var sectionName = self.trigger.attributes[1].stringify();
                    //console.log("toggled, isActive:", self.isActive);
                    if(self.isActive){
                        console.log(sectionName);
                        //console.log(self.trigger.dataset.section);
                        //console.log(self.trigger.attributes[1]);
                        $('.headingTrigger:not([data-section="'+sectionName+'"])').removeClass('active');
                        $('.headingTrigger[data-section="'+sectionName+'"]').addClass('active');
                    }

                },
                onUpdate: self => {
                    //console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
                }
            });

        });
      },

      // all 
      "all": function() {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.
      }

    }); 
	
  if($('#map').length){
  let map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: 52.491453, lng: 13.4211373 },
    zoom: 13,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: true,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    styles: [
    {
        "featureType": "all",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#d7b6f8"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "gamma": 0.01
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "saturation": -31
            },
            {
                "lightness": -33
            },
            {
                "weight": 2
            },
            {
                "gamma": 0.8
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 30
            },
            {
                "saturation": 30
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "saturation": 20
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 20
            },
            {
                "saturation": -20
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 10
            },
            {
                "saturation": -30
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "saturation": 25
            },
            {
                "lightness": 25
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "lightness": -20
            }
        ]
    }
]

  });

  new google.maps.Marker({
    map: map,
    position: { lat: 52.491453, lng: 13.4211373 }
  });
  }
  
	

});